export const createExampleCheckoutUrl = (
    urlSettings,
    firstExample,
    secondExample
) => {
    const {
        conversionUrlBase,
        interItemSeparator,
        intraItemSeparator,
        itemCodePrefix,
        itemListVarName,
        itemOptionalParamValue,
        optionalVars
    } = urlSettings;

    let optionalVarsString = '';
    if (optionalVars && optionalVars.length) {
        optionalVars.forEach((obj) => {
            if(obj.name && obj.value){
                optionalVarsString += `&${obj.name}=${obj.value}`
            }
        })
    }
    return `${Boolean(conversionUrlBase) ? conversionUrlBase : ``}
            ${Boolean(conversionUrlBase) && Boolean(itemListVarName) ? `?` : ``}
            ${Boolean(itemListVarName) ? itemListVarName : ``}
            ${firstExample.code !== '' || secondExample.code !== '' ? `=` : ``}
            ${Boolean(itemCodePrefix) && firstExample.code !== '' && firstExample.qty !== '' ? itemCodePrefix : ``}
            ${firstExample.code !== '' && firstExample.qty !== '' ? firstExample.code : ``}
            ${firstExample.code !== '' && firstExample.qty !== '' ? intraItemSeparator : ``}
            ${firstExample.code !== '' && firstExample.qty !== '' ? firstExample.qty : ``}
            ${Boolean(itemOptionalParamValue) && firstExample.code !== '' && firstExample.qty !== '' ? intraItemSeparator : ``}
            ${Boolean(itemOptionalParamValue) && firstExample.code !== '' && firstExample.qty !== '' ? itemOptionalParamValue : ``}
            ${(
        firstExample.code !== '' &&
        firstExample.qty !== '' &&
        secondExample.code !== '' &&
        secondExample.qty !== ''
    ) || (
        firstExample.code !== '' &&
        firstExample.qty !== '' &&
        optionalVarsString !== ''
    ) ? interItemSeparator : ``}
            ${Boolean(itemCodePrefix) && secondExample.code !== '' && secondExample.qty !== '' ? itemCodePrefix : ``}
            ${secondExample.code !== '' && secondExample.qty !== '' ? secondExample.code : ``}
            ${secondExample.code !== '' && secondExample.qty !== '' ? intraItemSeparator : ``}
            ${secondExample.code !== '' && secondExample.qty !== '' ? secondExample.qty : ``}
            ${Boolean(itemOptionalParamValue) && secondExample.code !== '' && secondExample.qty !== '' ? intraItemSeparator : ``}
            ${Boolean(itemOptionalParamValue) && secondExample.code !== '' && secondExample.qty !== '' ? itemOptionalParamValue : ``}
            ${optionalVarsString !== '' ? optionalVarsString : ``}
            `
        .replace(/\s/g, '');
    // ${optionalVarValue !== '' && optionalVarName !== '' ? `=` : ``}
    // ${optionalVarValue !== '' && optionalVarName !== '' ? optionalVarValue : ``}

}

export const createExampleCheckoutUrlApp = (
    urlSettings,
    firstExample,
    secondExample
) => {
    const {
        conversionUrlBaseApp,
        interItemSeparatorApp,
        intraItemSeparatorApp,
        itemCodePrefixApp,
        itemListVarNameApp,
        itemOptionalParamValueApp,
        optionalVarsApp
    } = urlSettings;

    let optionalVarsStringApp = '';
    if (optionalVarsApp && optionalVarsApp.length) {
        optionalVarsApp.forEach((obj) => {
            if(obj.name && obj.value){
                optionalVarsStringApp += `&${obj.name}=${obj.value}`
            }
        })
    }
    return `${Boolean(conversionUrlBaseApp) ? conversionUrlBaseApp : ``}
            ${Boolean(conversionUrlBaseApp) && Boolean(itemListVarNameApp) ? `?` : ``}
            ${Boolean(itemListVarNameApp) ? itemListVarNameApp : ``}
            ${firstExample.code !== '' || secondExample.code !== '' ? `=` : ``}
            ${Boolean(itemCodePrefixApp) && firstExample.code !== '' && firstExample.qty !== '' ? itemCodePrefixApp : ``}
            ${firstExample.code !== '' && firstExample.qty !== '' ? firstExample.code : ``}
            ${firstExample.code !== '' && firstExample.qty !== '' ? intraItemSeparatorApp : ``}
            ${firstExample.code !== '' && firstExample.qty !== '' ? firstExample.qty : ``}
            ${Boolean(itemOptionalParamValueApp) && firstExample.code !== '' && firstExample.qty !== '' ? intraItemSeparatorApp : ``}
            ${Boolean(itemOptionalParamValueApp) && firstExample.code !== '' && firstExample.qty !== '' ? itemOptionalParamValueApp : ``}
            ${(
        firstExample.code !== '' &&
        firstExample.qty !== '' &&
        secondExample.code !== '' &&
        secondExample.qty !== ''
    ) || (
        firstExample.code !== '' &&
        firstExample.qty !== '' &&
        optionalVarsStringApp && optionalVarsStringApp !== ''
    ) ? interItemSeparatorApp : ``}
            ${Boolean(itemCodePrefixApp) && secondExample.code !== '' && secondExample.qty !== '' ? itemCodePrefixApp : ``}
            ${secondExample.code !== '' && secondExample.qty !== '' ? secondExample.code : ``}
            ${secondExample.code !== '' && secondExample.qty !== '' ? intraItemSeparatorApp : ``}
            ${secondExample.code !== '' && secondExample.qty !== '' ? secondExample.qty : ``}
            ${Boolean(itemOptionalParamValueApp) && secondExample.code !== '' && secondExample.qty !== '' ? intraItemSeparatorApp : ``}
            ${Boolean(itemOptionalParamValueApp) && secondExample.code !== '' && secondExample.qty !== '' ? itemOptionalParamValueApp : ``}
            ${optionalVarsStringApp && optionalVarsStringApp !== '' ? optionalVarsStringApp : ``}
            `
        .replace(/\s/g, '');
    // ${optionalVarValue !== '' && optionalVarName !== '' ? `=` : ``}
    // ${optionalVarValue !== '' && optionalVarName !== '' ? optionalVarValue : ``}

}

export const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
